import VueTypes from 'vue-types';
import { isUuid } from './parse.js';
import { LOADER_STATUSES } from '../constants/status.js';

// added property checks before extending
// when executing "npm run test:watch" the following error happens on the second save
// TypeError: [VueTypes error]: Type "uuid" already defined

/* istanbul ignore else */
if (!VueTypes.uuid) {
    VueTypes.extend({
        name: 'uuid',
        getter: true,
        type: String,
        validator: (uuid) => isUuid(uuid),
    });
}

/* istanbul ignore else */
if (!VueTypes.status) {
    VueTypes.extend({
        name: 'status',
        getter: true,
        type: String,
        validator: (status) => Object.values(LOADER_STATUSES).includes(status),
    });
}

/* istanbul ignore else */
if (!VueTypes.nonEmptyString) {
    VueTypes.extend({
        name: 'nonEmptyString',
        type: String,
        validator: (value) => {
            if (value.length === 0) {
                throw new Error(
                    '[vf Vue Error]: prop cannot be an empty string!',
                );
            }
            return true;
        },
    });
}

export default VueTypes;
